import { render, staticRenderFns } from "./check.vue?vue&type=template&id=5319d743&"
import script from "./check.vue?vue&type=script&lang=js&"
export * from "./check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5319d743')) {
      api.createRecord('5319d743', component.options)
    } else {
      api.reload('5319d743', component.options)
    }
    module.hot.accept("./check.vue?vue&type=template&id=5319d743&", function () {
      api.rerender('5319d743', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/houseDeliveryManage/decorationRegistration/check.vue"
export default component.exports